export const FEATURE_FLAG_TOAST_MESSAGES = {
  TENANT_RBAC: "El módulo de Equipo no está disponible para tu proveedor",
};
